import React from 'react';
import { useBuildVersion } from '../../hooks/useBuildVersion';

/**
 * Muted, small build-identifier footer: "UI {ui} · API {api}" — or "UI {ui}" alone before the
 * API value resolves, or if the anonymous /api/version fetch never succeeds. No error state,
 * no loading spinner — see useBuildVersion for the graceful-degradation behavior.
 */
export const VersionFooter: React.FC = () => {
  const { uiVersion, apiVersion } = useBuildVersion();

  return (
    <footer className="py-4 text-center text-xs text-muted">
      UI {uiVersion}{apiVersion ? ` · API ${apiVersion}` : ''}
    </footer>
  );
};
